import { ListContentIsland, NotYetListItem, TransactionIcon } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';

export function NoMoreDestinations() {
  const { t } = useTranslation();

  return (
    <ListContentIsland>
      <NotYetListItem
        title={t('You have distributed 100% of the order')}
        icon={<TransactionIcon />}
      />
    </ListContentIsland>
  );
}
